import styled from "styled-components";
import { theme } from "./theme";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";

export const STabs = styled(Tabs)`
	padding: 3rem 0;
	width: 100%;
`;

export const STabList = styled(TabList)`
	position: relative;
	list-style: none;
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	&::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		border-bottom: 0.1rem solid ${theme.color.black};
		width: 100%;
	}

	li {
		margin-right: 2rem;

		&:last-child {
			margin: 0;
		}
	}

	&.disabled {
		&::after {
			opacity: 0.5;
		}
	}
`;
STabList.tabsRole = "TabList";

export const STab = styled(Tab)`
	position: relative;
	background-color: transparent;
	border: none;
	font-family: ${theme.font.secondary};
	font-size: 1.2rem;
	font-weight: 500;
	text-transform: uppercase;
	padding: 0.5rem 1.5rem;
	color: ${theme.color.black};
	display: inline-block;
	white-space: nowrap;
	outline: none;
	cursor: pointer;

	&::before {
		display: block;
		content: attr(title);
		font-weight: 900;
		height: 0;
		overflow: hidden;
		visibility: hidden;
	}

	&::after {
		content: "";
		position: absolute;
		left: 0;
		bottom: 0;
		border-bottom: 0.3rem solid ${theme.color.black};
		width: 0;
		opacity: 0;
		transition: width 0.3s, opacity 0.2s;
	}

	&.is-selected {
		font-weight: 900;

		&::after {
			opacity: 1;
			width: 100%;
		}
	}

	&.react-tabs__tab--disabled {
		opacity: 0.5;
		cursor: auto;
	}
`;
STab.tabsRole = "Tab";

export const STabPanel = styled(TabPanel)`
	padding: 3rem 0;
	display: none;

	&.is-selected {
		display: block;
	}

	&.disabled {
		display: none;
	}

	& > h3:not(:first-child) {
		margin-top: 2rem;
	}

	& > h3 {
		margin-bottom: 1rem;
	}
`;
STabPanel.tabsRole = "TabPanel";
